import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { generateKindnessId } from '../utils/kindnessId';

const { FiCopy, FiRefreshCw, FiUser, FiHeart } = FiIcons;

const KindnessIdCard = ({ kindnessId, setKindnessId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyId = async () => {
    try {
      await navigator.clipboard.writeText(kindnessId);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy ID:', err);
    }
  };

  const handleGenerateNew = () => {
    const newId = generateKindnessId();
    setKindnessId(newId);
  };

  const handleShowExisting = () => {
    const savedId = localStorage.getItem('nakamoto-kindness-id');
    if (savedId) {
      setKindnessId(savedId);
    }
  };

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.1, duration: 0.5 }}
      className="clay-card mobile-spacing mb-8"
    >
      <div className="flex items-center space-x-4 mb-6">
        <div className="clay-button-yellow p-4">
          <SafeIcon icon={FiUser} className="text-2xl text-text" />
        </div>
        <h2 className="text-2xl font-bold text-heading">Your Kindness ID</h2>
      </div>

      <div className="clay-card bg-green p-4 mb-6 flex flex-wrap items-center justify-between gap-4">
        <span className="font-mono text-xl font-bold text-heading break-words flex-1">
          {kindnessId}
        </span>
        <button
          onClick={handleCopyId}
          className={`clay-button-pink px-4 py-2 flex items-center space-x-2 font-bold transition-all duration-300 focus-visible ${
            copied ? 'transform scale-110' : 'hover:transform hover:scale-105'
          }`}
        >
          <SafeIcon icon={FiCopy} className="text-lg text-text" />
          <span>{copied ? 'Copied!' : 'Copy'}</span>
        </button>
      </div>

      <div className="flex flex-wrap gap-4">
        <button
          onClick={handleGenerateNew}
          className="clay-button-purple px-6 py-3 flex items-center space-x-2 font-bold hover:transform hover:scale-105 transition-all duration-300 focus-visible"
        >
          <SafeIcon icon={FiRefreshCw} className="text-lg text-text" />
          <span>Generate New</span>
        </button>

        <button
          onClick={handleShowExisting}
          className="clay-button-yellow px-6 py-3 flex items-center space-x-2 font-bold hover:transform hover:scale-105 transition-all duration-300 focus-visible"
        >
          <SafeIcon icon={FiUser} className="text-lg text-text" />
          <span>Use Existing</span>
        </button>
      </div>

      <div className="mt-6 clay-card bg-pink p-4">
        <p className="text-text text-center font-bold flex items-center justify-center space-x-2">
          <SafeIcon icon={FiHeart} className="heart-logo" />
          <span>Save this ID somewhere safe! It's your only way to return as the same sender.</span>
        </p>
      </div>
    </motion.div>
  );
};

export default KindnessIdCard;